import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuthStore } from '@stores/auth-store';
import { signOut } from '@features/user/service';
import * as ToastUtil from '@utils/toast-utils';

export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut: authSignOut } = useAuthStore();

  const handleMenuClose = () => {
    document.body.classList.remove('hidden');
    document.querySelector('.header')?.classList.remove('open');
    document.querySelector('.navbox')?.classList.remove('open');
  };

  const handleSignOut = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const result = await signOut();
    if (result.status === 200) {
      authSignOut();
      handleMenuClose();
      navigate('/');
      ToastUtil.success('EyeTMarket에서 로그아웃하였습니다.');
    }
  };

  return (
    <div className="navbox">
      <div className="headbox" style={{ display: user ? 'none' : 'block' }}>
        <button className="menu_close" onClick={handleMenuClose}></button>
        <p className="title">회원가입하고 다양한 혜택 받으세요</p>
        <div className="top_nav">
          <a
            href={`/sign-in?returnTo=${encodeURIComponent(location.pathname + location.search)}`}
            className="link"
            onClick={handleMenuClose}
          >
            로그인
          </a>
          <span className="bar"></span>
          <Link to="/sign-up" className="link" onClick={handleMenuClose}>
            회원가입
          </Link>
        </div>
      </div>
      <div className="headbox" style={{ display: user ? 'block' : 'none' }}>
        <button className="menu_close" onClick={handleMenuClose}></button>
        <p className="title">
          <span className="name">{user?.nickname || user?.loginId || '홍길동'}님</span>, 환영합니다 :)
        </p>
        <div className="top_nav">
          <a href="#none" className="link" onClick={handleSignOut}>
            로그아웃
          </a>
          <span className="bar"></span>
          <Link to="/my-page" className="link" onClick={handleMenuClose}>
            마이페이지
          </Link>
          {user?.role === 'ADMIN' && (
            <>
              <span className="bar"></span>
              <Link to="/admin" className="link" onClick={handleMenuClose}>
                관리자 페이지
              </Link>
            </>
          )}
        </div>
      </div>
      <ul className="inner menubox accordion">
        {/* <li>
          <div className="title acc_tit">
            <span className="tit">메뉴 이름</span>
            <span className="icon"></span>
          </div>
          <ul className="acc_cont">
            <li>
              <a href="" className="link">
                서브 메뉴 이름
              </a>
            </li>
          </ul>
        </li> */}
        <li>
          <Link
            to="/product-intro"
            className={`title link ${location.pathname === '/product-intro' ? 'active' : ''}`}
            onClick={handleMenuClose}
          >
            제품 소개
          </Link>
        </li>

        <li>
          <Link
            to="/products"
            className={`title link ${location.pathname === '/products' || (location.pathname.startsWith('/products/') && location.pathname !== '/product-intro') ? 'active' : ''}`}
            onClick={handleMenuClose}
          >
            분석 스토어
          </Link>
        </li>

        <li>
          <Link
            to="/inquiry"
            className={`title link ${location.pathname === '/inquiry' ? 'active' : ''}`}
            onClick={handleMenuClose}
          >
            문의하기
          </Link>
        </li>

        <li>
          <Link
            to="/education-course"
            className={`title link ${location.pathname === '/education-course' ? 'active' : ''}`}
            onClick={handleMenuClose}
          >
            교육과정
          </Link>
        </li>

        <li>
          <Link
            to="/analysis-request"
            className={`title link ${location.pathname === '/analysis-request' ? 'active' : ''}`}
            onClick={handleMenuClose}
          >
            분석 의뢰하기
          </Link>
        </li>
      </ul>
    </div>
  );
};
